import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  required,
  minLength,
  email,
  BooleanInput,
  FormDataConsumer,
} from 'react-admin'
import { EmailVerificationInfoAlert } from '../../components/EmailVerificationAlerts';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { CPFInput } from '../../components/Inputs';
import { EmployeeType } from '../../models';
import { getChainId } from '../../lib';

const profilesSx = {
  width: 220,
};

const validateEmail = [required(), email()];
const validatePassword = [required(), minLength(6)];

export default props => {
  return (
    <Permission permission={PERMISSIONS.CREATE_PROMOTER}>
      <Create {...props} title="Cadastrar novo promoter">
        <SimpleForm defaultValues={{ chainId: getChainId(), type: EmployeeType.promoter }} sx={{ maxWidth: 600 }}>
          <Permission permission={PERMISSIONS.ADMIN} >
            <ReferenceInput {...props} label="Rede" source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={null}>
              <SelectInput optionText="name" InputProps={{ autoComplete: 'off' }} validate={[required()]} />
            </ReferenceInput>
          </Permission>
          <TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <CPFInput source="cpf" label="CPF" sx={{ minWidth: 300 }} />
          <TextInput source="login" label="Login" validate={validateEmail} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} sx={{ minWidth: 300 }} />
          <TextInput
            source="code"
            label="Código"
            inputProps={{
              maxLength: 32,
            }}
            InputProps={{ autoComplete: 'off' }}
            parse={value => value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()}
            sx={{ minWidth: 300 }}
          />
          <FormDataConsumer>
            {({ formData }) => (
              <ReferenceInput
                sx={profilesSx}
                label="Perfil"
                source="profileId"
                reference={'profiles'}
                filter={{ chainId: formData.chainId }}
                sort={{ field: 'name', order: 'ASC' }}
                // @ts-ignore
                perPage={null}
              >
                <RadioButtonGroupInput label="Perfil" optionText="name" validate={[required()]} />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
          <EmailVerificationInfoAlert />
        </SimpleForm>
      </Create>
    </Permission>
  );
}
